import { render, staticRenderFns } from "./fashionMarket.vue?vue&type=template&id=3bfe5981&scoped=true"
import script from "./fashionMarket.vue?vue&type=script&lang=js"
export * from "./fashionMarket.vue?vue&type=script&lang=js"
import style0 from "./fashionMarket.vue?vue&type=style&index=0&id=3bfe5981&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfe5981",
  null
  
)

export default component.exports